import {
	PostRequestPreRegisterParams,
	PostRequestPreRegisterResponse,
} from 'domain/usecases/others/facial-biometric';
import {makePostRequestFacialBiometricPreRegister} from 'main/factories/usecases/others/facial-biometric/request/post-pre-register';

export const postPreRegister = async (
	params: PostRequestPreRegisterParams,
): Promise<PostRequestPreRegisterResponse> => {
	const response = await makePostRequestFacialBiometricPreRegister().post(params);
	return response;
};
